import { Box, Typography } from '@mui/material';
import { useQuizState } from '@providers/QuizProvider/QuizProvider.hooks';
import QuizButton, { ButtonType } from '../../common/QuizButton';
import QuizContainer from '../../common/QuizContainer';
import QuizStepBackgroundWrapper from '../../common/QuizStepBackgroundWrapper';

function Goal() {
  const { setStep, quizData } = useQuizState();
  const handleClick = () => {
    setStep((prev) => prev + 1);
  };
  return (
    <QuizStepBackgroundWrapper>
      <QuizContainer>
        <Box
          sx={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '20px',
          }}
        >
          <img src="/refuse/images/quiz/goal.webp" width={209} height={160} />
          <Box>
            <Typography
              sx={{
                fontFamily: 'Avenir500',
                textAlign: 'center',
                color: '#ED744E',
                marginBottom: '10px',
                fontSize: '15px',
              }}
            >
              A goal clearly set is halfway reached!
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Avenir600',
                color: '#282624',
                fontSize: '24px',
                textAlign: 'center',
                userSelect: 'none',
                marginBottom: '10px',
              }}
            >
              Congrats, you've embarked on your journey to a happier, healthier
              life.
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Avenir400',
                textAlign: 'center',
                color: '#908C89',
              }}
            >
              We've got eveything you need to ensure success
            </Typography>
          </Box>
          <QuizButton
            variant={ButtonType.ORANGE}
            text="Continue"
            onClick={handleClick}
          />
        </Box>
      </QuizContainer>
    </QuizStepBackgroundWrapper>
  );
}

export default Goal;
